import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	allCars: {},
	leasedCars: [],
	isLoaded: false
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.CAR_FETCHED_ALL:
		return state.merge({
			allCars: action.allCars,
			isLoaded: true
		});
	case types.CAR_FETCHED_LEASED:
		return state.merge({
			leasedCars: action.leasedCars
		});
	default:
		return state;
	}
}
